export function createDeveloperToolsSidebarItem({ userActions, userSubjects }) {
  return {
    $ID: 'DeveloperTools',
    Icon: 'developer-tools',
    IconClass: 'fill-icon',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.developerTools',
    group: 'main',
    filterChildrenByAbility: true,
    Items: [
      {
        $ID: 'BeedigitApi',
        Action: {
          $Type: 'OpenPage',
          Page: 'BeedigitApi',
        },
        Icon: 'api-keys',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.apiKeys',
        group: 'main',
        ability: {
          subject: userSubjects.API_KEY,
          action: userActions.READ,
        },
      },
      {
        $ID: 'Webhooks',
        Action: {
          $Type: 'OpenPage',
          Page: 'Webhooks',
        },
        Icon: 'webhooks',
        ViewBox: '0 0 24 24',
        Caption: 'sidebar.titles.webhooks',
        group: 'main',
        ability: {
          subject: userSubjects.WEBHOOKS,
          action: userActions.READ,
        },
      },
    ],
  };
}

export function createManufacturingSidebarItem({ userActions, userSubjects }) {
  return {
    $ID: 'Manufaction',
    Icon: 'factory',
    IconClass: 'fill-icon',
    Caption: 'sidebar.titles.manufacturing',
    group: 'main',
    showLock: true,
    filterChildrenByAbility: true,
    Items: [
      {
        $ID: 'JobOrders',
        Action: {
          $Type: 'OpenPage',
          Page: 'JobOrders',
        },
        Icon: 'job-orders',
        IconClass: 'fill-icon',
        ViewBox: '0 -960 960 960',
        Caption: 'sidebar.titles.jobOrders',
        group: 'main',
        ability: {
          subject: userSubjects.JOB_ORDERS,
          action: userActions.READ,
        },
      },
      {
        $ID: 'WorkCenterCapacity',
        Action: {
          $Type: 'OpenPage',
          Page: 'WorkCenterCapacity',
        },
        Icon: 'readiness-score',
        IconClass: 'fill-icon',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.workCenterCapacity',
        group: 'main',
        ability: {
          subject: userSubjects.JOB_ORDERS,
          action: userActions.READ,
        },
      },
      {
        $ID: 'Output',
        Action: {
          $Type: 'OpenPage',
          Page: 'Output',
        },
        Icon: 'output',
        IconClass: 'fill-icon',
        ViewBox: '0 -960 960 960',
        Caption: 'sidebar.titles.output',
        group: 'main',
        ability: {
          subject: userSubjects.OUTPUTS,
          action: userActions.READ,
        },
      },
      {
        $ID: 'SerialNumbers',
        Action: {
          $Type: 'OpenPage',
          Page: 'SerialNumbers',
        },
        Icon: 'serial-numbers',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.serialNumbers',
        group: 'main',
        ability: {
          subject: userSubjects.SERIAL_NUMBERS,
          action: userActions.READ,
        },
      },
      {
        $ID: 'Shifts',
        Action: {
          $Type: 'OpenPage',
          Page: 'Shifts',
        },
        Icon: 'shifts',
        IconClass: 'fill-icon',
        ViewBox: '0 -960 960 960',
        Caption: 'sidebar.titles.shifts',
        group: 'main',
        ability: {
          subject: userSubjects.SHIFTS,
          action: userActions.READ,
        },
      },
    ],
  };
}

export function createLossesSidebarItem({ userActions, userSubjects }) {
  return {
    $ID: 'EffieciencyLoss',
    Icon: 'losses',
    Caption: 'sidebar.titles.losses',
    group: 'main',
    showLock: true,
    filterChildrenByAbility: true,
    Items: [
      {
        $ID: 'AvailabilityLosses',
        Action: {
          $Type: 'OpenPage',
          Page: 'AvailabilityLosses',
        },
        Icon: 'metric-availability',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.availabilityLosses',
        group: 'main',
        ability: {
          subject: userSubjects.LOSSES,
          action: userActions.READ,
        },
      },
      {
        $ID: 'PerformanceLosses',
        Action: {
          $Type: 'OpenPage',
          Page: 'PerformanceLosses',
        },
        Icon: 'metric-performance',
        ViewBox: '0 0 20 20',
        Caption: 'sidebar.titles.performanceLosses',
        group: 'main',
        ability: {
          subject: userSubjects.LOSSES,
          action: userActions.READ,
        },
      },
      {
        $ID: 'QualityLosses',
        Action: {
          $Type: 'OpenPage',
          Page: 'QualityLosses',
        },
        Icon: 'metric-quality',
        ViewBox: '0 0 21 20',
        Caption: 'sidebar.titles.qualityLosses',
        group: 'main',
        ability: {
          subject: userSubjects.LOSSES,
          action: userActions.READ,
        },
      },
    ],
  };
}

function isSidebarItemAvailable(item, can) {
  return !item.ability || can(item.ability.action, item.ability.subject) || item.showLock;
}

export function sidebarContainsRoute(items, routeName) {
  return items.some((item) => {
    return (
      item.Action?.Page === routeName ||
      (item.Items?.length ? sidebarContainsRoute(item.Items, routeName) : false)
    );
  });
}

export function filterSidebarItemsByAbility(items, can) {
  return items.reduce((availableItems, item) => {
    if (!isSidebarItemAvailable(item, can)) {
      return availableItems;
    }

    if (!item.filterChildrenByAbility || !item.Items) {
      availableItems.push(item);
      return availableItems;
    }

    const Items = filterSidebarItemsByAbility(item.Items, can);
    if (Items.length) {
      availableItems.push({ ...item, Items });
    }

    return availableItems;
  }, []);
}
export function buildSidebarDestination(item, route, siblings) {
  const preserveQuery =
    item.Action.Page === route.name ||
    (item.Action.PreserveQuery === true &&
      siblings.some(
        (sibling) => sibling.Action.Page === route.name && sibling.Action.PreserveQuery === true,
      ));
  return {
    name: item.Action.Page,
    hash: item.Action.Hash,
    query: preserveQuery ? route.query : undefined,
  };
}

export function createAnalyticsSidebarItem({ userActions, userSubjects }) {
  const analyticsAbility = { action: userActions.READ, subject: userSubjects.ANALYTICS };
  return {
    $ID: 'Analytics',
    Icon: 'analytics',
    ViewBox: '0 0 20 20',
    Caption: 'sidebar.titles.analytics',
    group: 'main',
    ability: analyticsAbility,
    filterChildrenByAbility: true,
    Items: [
      ['AnalyticsOverview', 'analytics.overview', 'analytics-overview', '0 0 20 20'],
      ['AnalyticsOee', 'analytics.oee', 'metric-oee', '0 0 20 20'],
      [
        'AnalyticsWorkCenterEfficiency',
        'analytics.workCenterEfficiency',
        'donut-large',
        '0 0 20 20',
        'fill-icon',
      ],
      ['AnalyticsPerformance', 'analytics.performance', 'speedometer', '0 0 20 20'],
      ['AnalyticsQuality', 'analytics.quality', 'metric-quality', '0 0 21 20'],
      ['AnalyticsDowntimeReasons', 'analytics.downtimes', 'clock', '0 0 20 20'],
      [
        'AnalyticsClassificationResponse',
        'analytics.classificationResponse',
        'stopwatch',
        '0 0 20 20',
      ],
      ['AnalyticsOutput', 'analytics.output', 'output', '0 -960 960 960', 'fill-icon'],
      ['AnalyticsEnergy', 'analytics.energyConsumption', 'zap', '0 0 24 24'],
      ['AnalyticsChecklists', 'analytics.checklists', 'checklists', '0 0 20 20'],
      ['AnalyticsUserActivity', 'analytics.userActivity', 'user-sidebar', '0 0 20 20'],
    ].map(([$ID, Caption, Icon, ViewBox, IconClass]) => {
      let ability = analyticsAbility;
      if ($ID === 'AnalyticsChecklists') {
        ability = { action: userActions.READ, subject: userSubjects.CHECKLISTS };
      }
      if ($ID === 'AnalyticsUserActivity') {
        ability = { action: userActions.READ, subject: userSubjects.COMPANY_USERS };
      }

      return {
        $ID,
        Caption,
        Icon,
        ViewBox,
        IconClass,
        Action: { $Type: 'OpenPage', Page: $ID, PreserveQuery: true },
        ability,
      };
    }),
  };
}

export function createPerformanceSidebarItem({ userActions, userSubjects }) {
  return {
    $ID: 'AnalyticsPerformance',
    Action: { $Type: 'OpenPage', Page: 'AnalyticsPerformance' },
    Icon: 'speedometer',
    ViewBox: '0 0 24 24',
    Caption: 'analytics.performance',
    group: 'main',
    ability: { subject: userSubjects.ANALYTICS, action: userActions.READ },
  };
}
